import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const useStyles = makeStyles(theme => ({
  root: {
    width: '176px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
      width: '100%',
      '&:nth-of-type(2)': {
        borderTop: `1px solid ${theme.palette.borders.primary}`,
        marginTop: '10px',
        paddingTop: '1rem'
      }
    },
    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(2)': {
        paddingTop: 0,
        borderTop: 0,
        marginLeft: '20px'
      },
      marginTop: 0
    }
  }
}));

const LocationCardFulfillmentTypeGridItem = ({ children, isFullWidth }) => {
  const classes = useStyles({ isFullWidth });
  return <div className={classes.root}>{children}</div>;
};

LocationCardFulfillmentTypeGridItem.propTypes = {
  children: CHILDREN_PROPTYPES.isRequired,
  isFullWidth: PropTypes.bool
};

LocationCardFulfillmentTypeGridItem.defaultProps = {
  isFullWidth: false
};

export default LocationCardFulfillmentTypeGridItem;
